import { render } from "./DuplicateDataModal.component.vue?vue&type=template&id=0f82df14&scoped=true&ts=true"
import script from "./DuplicateDataModal.component.vue?vue&type=script&lang=ts"
export * from "./DuplicateDataModal.component.vue?vue&type=script&lang=ts"

import "./DuplicateDataModal.component.vue?vue&type=style&index=0&id=0f82df14&lang=scss&scoped=true"

import exportComponent from "/builds/anisen/datamanagerweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f82df14"]])

export default __exports__